import { Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import { DocumentStatus, DocumentType, Source } from "@/briefpoint-client";
import type { DocumentClient } from "@/lib/types";
import Button from "../Button";

function StartButton({ documentId }: { documentId: string }) {
  return (
    <Link
      className="btn btn-outline-primary btn-26"
      to={`/wizard/${documentId}/source-document-review`}
    >
      Start
    </Link>
  );
}

function ReviewButton({
  documentId,
  type,
}: {
  documentId: string;
  type: DocumentType;
}) {
  return (
    <Link
      className="btn btn-outline-primary btn-26"
      to={`/wizard/${type === DocumentType.Pleading ? "propound/" : ""}${documentId}`}
    >
      Review
    </Link>
  );
}

function ProcessingButton() {
  return (
    <Button variant="outline" size="sm" disabled>
      <Spinner animation="border" size="sm" /> Processing...
    </Button>
  );
}

function FinishDraftButton({ document }: { document: DocumentClient }) {
  return (
    <Link
      className="btn btn-outline-primary btn-26"
      to={`/clients/${document.clientId}/cases/${document.caseId}/generateDiscoveryRequest?documentId=${document.id}`}
    >
      {document.lastWordDownloadDate ? "Edit" : "Finish"}
    </Link>
  );
}

function FinishButton({
  documentId,
  type,
}: {
  documentId: string;
  type: DocumentType;
}) {
  return (
    <Link
      className="btn btn-outline-primary btn-26"
      to={`/wizard/${type === DocumentType.Pleading ? "propound/" : ""}${documentId}`}
    >
      Continue
    </Link>
  );
}

export function DocumentAction({ document }: { document?: DocumentClient }) {
  if (document?.source === Source.InternalGenerated) {
    return <FinishDraftButton document={document} />;
  }

  if (!document?.status) return <ProcessingButton />;

  switch (document?.status as DocumentStatus) {
    case DocumentStatus.InfoConfirmed:
      return (
        <FinishButton
          documentId={document?.id ?? ""}
          type={document.info?.documentType ?? DocumentType.Unknown}
        />
      );
    case DocumentStatus.Complete:
      return (
        <ReviewButton
          documentId={document?.id ?? ""}
          type={document?.info?.documentType ?? DocumentType.Unknown}
        />
      );
    case DocumentStatus.Processed:
      return <StartButton documentId={document?.id ?? ""} />;
    case DocumentStatus.Unknown:
    case DocumentStatus.Uploaded:
    case DocumentStatus.Processing:
    case DocumentStatus.Deleted:
    case DocumentStatus.Error:
      return <ProcessingButton />;
    default:
      return DocumentStatus[document?.status];
  }
}
